
































































































































































































































































































import { Component, Vue, Provide } from "vue-property-decorator";
import { localGet, setMetaData, timeFormat, downloadFile } from "@/utils";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import { pagnition } from "@/utils/commonConfig";
import { GetTicketListParamReq } from "@/pbjs/external/ticket/ticket_pb";
import { ticketClient } from "@/api/index";

@Component({
  name: "PerformanceList",
  components: {},
})
export default class CombinationProperty extends Vue {
  @Provide() private ruleForm: any = {
    Statstype: "",
    Email: "",
    Username: "",
    Usergroupid: "",
    Itemid: "",
    Timerange: "",
  };
  @Provide() private subItem: any = false;
  @Provide() private AppName: any = "";
  @Provide() private AppOpnList: any = [];
  @Provide() private pickTime: any = ""; // 小时
  @Provide() private pickTimeOptions: Array<String> = [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ];
  @Provide() private isHoured: boolean = false; // 是否显示小时
  @Provide() private issearchDone: boolean = false;
  @Provide() private issearchByday: boolean = false;
  @Provide() private downLoadDone: boolean = false;
  // 角色
  @Provide() private roleData: any = [];
  @Provide() private execType: number | null = null; //角色

  @Provide() private updatatime: string = "20";
  @Provide() private employId: string = "";
  @Provide() private resultData: any = [];
  @Provide() private pagnition: any = pagnition; // lee 分页参数
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private sortCondition: any = {
    prop: null,
    order: null,
  };
  @Provide() private parameterData: any = [
    { id: 100, name: "PV" },
    { id: 107, name: "CPV" },
    { id: 101, name: "IR" },
    { id: 102, name: "QI" },
  ]; //审核类型
  @Provide() private StatstypeData: any = []; //角色
  private created() {
    this.StatstypeData = [
      { id: 100, name: "PV" },
      // { id: 107, name: "CPV" },
      { id: 101, name: "IR" },
      { id: 102, name: "QI" },
      { id: 201, name: this.$t("ticketLgy.All") },
    ];
    this.getRoleList();
    this.getTicketListParam();
  }
    //  进入页面调取，查询需要的select下拉框
  private getTicketListParamFuc(data: any) {
    // 项目列表
    let AppOpnList=JSON.parse(data.applist)
     Object.keys(AppOpnList).forEach((item:any) => {
       this.AppOpnList.push({
         codeName: AppOpnList[item], code: null, channel: item
       })
     });
  }
  private getTicketListParam() {
    let request: any = new GetTicketListParamReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketListParam(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        let _fuc = this.getTicketListParamFuc;
        handleResponse(data, _fuc);
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  private onCheckSubItem(val) {
    if(!val) {
      this.AppName = ''
    }
  }
  private params() {
    let AppName:string;
      this.AppOpnList.forEach((item:any) => {
        if (item.channel==this.AppName) {
          AppName=item.channel
        }
      }); 
    let _arg: any = {
      Statstype: this.ruleForm.Statstype,
      Email: this.ruleForm.Email,
      Username: this.ruleForm.Username,
      Usergroupid: this.ruleForm.Usergroupid,
      Itemid: this.ruleForm.Itemid,
      AppName: AppName,
      IsAll: this.subItem ? 1 : 0,
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      prop: this.sortCondition.prop,
      order: this.sortCondition.order,
    };
    if (
      this.ruleForm.Timerange &&
      this.ruleForm.Timerange.length > 0 &&
      this.ruleForm.Timerange[0]
    ) {
      // 开始时间 - 结束时间
      _arg.Timerange =
        timeFormat(this.ruleForm.Timerange[0]) +
        " - " +
        timeFormat(this.ruleForm.Timerange[1]);
    }
    if (this.isHoured) {
        _arg.Hour = `${this.pickTime}`;
      }
    return _arg;
  }
  //  private addButton() {
  //   this.isDateButton = true;
  // }
  //  处理 日期时间选择操作
  private pickerAction(val: any) {
    // return;
    if(!val) {
      this.isHoured = false;
      this.pickTime = null;
      return;
    }
    let opt = val;
    var _maxDate=null;//初始化
    var _maxTime=null;//初始化
    let  _minDate = new Date(opt[0]);
    let _minTime = _minDate.getFullYear() + _minDate.getMonth() + _minDate.getDate();
    _maxDate = new Date(opt[1]);
    _maxTime = _maxDate.getFullYear() + _maxDate.getMonth() + _maxDate.getDate();
    if(new Date(opt[0]).getTime() === new Date(opt[1]).getTime()){
      this.isHoured = true;
      let _compareStamp = new Date(_minTime).getTime();
      let _hour =  _minDate.getDate();
      let _now = new Date();
      let _nowTimeStamp = new Date(_now.getFullYear() + _now.getMonth() + _now.getDate()).getTime();
      // 默认展示当前的小时，向上取整；如果不是当天展示23
      if(_compareStamp == _nowTimeStamp) {
        if(_hour == 23) {
          this.pickTime = 23;
        } else {
          this.pickTime = _now.getHours() + 1;
        }
      }else{
        this.pickTime = 23;
      }
    }else{
      this.isHoured = false;
    }
  }
  //获取列表数据
  private async getIlstData() {
    if (!this.ruleForm.Timerange || this.ruleForm.Timerange.length < 2) {
      this.issearchDone = false;
      this.$message({
        type: "warning",
        message: `${this.$t("tipsWrh.enterChooseTime")}`,
      });
      return;
    }
    const { getListPhoneVerifyStatsReq, getListPhoneVerifyStatsRequest }: any =
      await import("@/request/DataModule");
    let res = await getListPhoneVerifyStatsRequest.handleHttp(
      getListPhoneVerifyStatsReq(this.params()),
      this
    );
    if (res && res.right) {
      this.resultData = res.listList;
      this.pagerCount = res.pageout.total;
    } else {
    }
    this.issearchDone = false;
    this.issearchByday = false;
  }
  getIlst(index: number) {
    this.ruleForm.Statstype = index;
    if (index == 1 || index == 2) {
      this.issearchByday = true;
    } else {
      this.issearchDone = true;
    }
    this.getIlstData();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getIlstData();
  }
  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getIlstData();
  }
  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getIlstData();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getIlstData();
  }
  private async getRoleList() {
    let _arg: any = {
      execType: '3' //sessionStorage.getItem("exectype"),
    };
    const { setListUserGroupByTypeReq, getListUserGroupByTypeRequest }: any =
      await import("@/request/staffManagement");
    let res = await getListUserGroupByTypeRequest.handleHttp(
      setListUserGroupByTypeReq(_arg),
      null
    );
    if (res && res.right) {
      if (res.usergroupinfosList && res.usergroupinfosList.length > 0) {
        this.roleData = res.usergroupinfosList;
      } else {
        this.roleData = [];
      }
    } else {
      this.$message.error(res.commonout.errmsg);
    }
  }
  //  lee 导出操作
  private async exportFormAction(index: number) {
    this.ruleForm.Statstype = index;
    if (!this.ruleForm.Timerange || this.ruleForm.Timerange.length < 2) {
      this.issearchDone = false;
      this.$message({
        type: "warning",
        message: `${this.$t("tipsWrh.enterChooseTime")}`,
      });
      return;
    }
    let arg = this.params();
    const { getListPhoneVerifyStatsExcelReq }: any = await import(
      "@/request/DataModule"
    );
    let response = await getListPhoneVerifyStatsExcelReq(arg, this);
    if (response) {
      if ((response.array[3] && response, response.array[3].length > 0)) {
        const blob = new Blob([response.array[3]], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        downloadFile(blob, response.array[2]);
      }
    }
  }

  private sortChange(val: any) {
    switch (val.prop) {
      case "passrate":
        this.sortCondition.prop = 24;
        break;
      case "invalidrate":
        this.sortCondition.prop = 25;
        break;
      case "rejectrate":
        this.sortCondition.prop = 26;
        break;
    }
    switch (val.order) {
      case "descending":
        this.sortCondition.order = 2;
        break;
      case "ascending":
        this.sortCondition.order = 1;
        break;
      default:
        this.sortCondition.order = 2;
        break;
    }
    this.getIlstData();
  }
}
